export const monthNames = [
    'January',
    'February',
    'March', 
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

export const months = monthNames.map((e, i) => { return { id: i + 1, value: e } });

export function getDateString(month, year) {

    return `${months[month - 1].value} ${new Date(year, month, 0).getDate()}, ${year}`;
}


// WEBPACK FOOTER //
// ./src/helpers/dateHelpers.js